export default function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover z-0"
      >
        <source src="https://xbqwyqjd.manus.space/coworking_agency.mp4" type="video/mp4" />
      </video>

      <div className="absolute inset-0 bg-gradient-to-br from-black/80 via-black/60 to-red-900/40 z-10"></div>

      <div className="absolute inset-0 z-10">
        <div className="absolute top-20 left-10 w-20 h-20 bg-red-600 rounded-full opacity-20 animate-pulse"></div>
        <div className="absolute top-40 right-20 w-16 h-16 bg-red-400 rounded-full opacity-30 animate-pulse" style={{ animationDelay: '0.5s' }}></div>
        <div className="absolute bottom-40 left-20 w-24 h-24 bg-red-500 rounded-full opacity-25 animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute bottom-20 right-10 w-12 h-12 bg-red-300 rounded-full opacity-35 animate-pulse" style={{ animationDelay: '1.5s' }}></div>
      </div>

      <div className="relative z-20 container mx-auto px-4 text-center text-white">
        <div className="transition-all duration-1000 opacity-100 translate-y-0">
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold mb-6 leading-tight">
            <span className="inline-block animate-pulse text-red-500">CRESCIMENTO DIGITAL</span>
          </h1>

          <p className="text-xl md:text-2xl mb-8 text-gray-300 max-w-4xl mx-auto leading-relaxed">
            Somos a <strong className="text-red-400">IchiBan Marketing Digital</strong>, uma agência que atua no mercado de marketing digital para todos os tipos de negócios, utilizando <strong className="text-red-400">Inteligência Artificial</strong> como suporte para diversas operações nas campanhas e estratégias digitais, com foco em <strong className="text-red-400">Growth Marketing</strong> como estratégia de crescimento dos resultados das empresas.
          </p>

          <div className="flex flex-wrap justify-center gap-6 mb-12">
            <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
              <i className="ri-line-chart-line text-red-400"></i>
              <span className="text-sm font-medium">Growth Marketing</span>
            </div>
            <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
              <i className="ri-robot-line text-red-400"></i>
              <span className="text-sm font-medium">Inteligência Artificial</span>
            </div>
            <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
              <i className="ri-global-line text-red-400"></i>
              <span className="text-sm font-medium">Equipe Sem Fronteiras</span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-gradient-to-r from-red-600 to-red-500 text-white px-8 py-4 rounded-full font-semibold text-lg hover:shadow-xl transition-all duration-300 hover:scale-105 flex items-center space-x-2 animate-pulse whitespace-nowrap cursor-pointer"
            >
              <span>Acelere seu Crescimento</span>
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white hover:text-gray-900 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Conheça Nossa História
            </button>
          </div>

          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-red-400 mb-2">100+</div>
              <div className="text-sm text-gray-400">Projetos Realizados</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-red-400 mb-2">50+</div>
              <div className="text-sm text-gray-400">Clientes Satisfeitos</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-red-400 mb-2">300%</div>
              <div className="text-sm text-gray-400">Crescimento Médio</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-red-400 mb-2">24/7</div>
              <div className="text-sm text-gray-400">Suporte Sem Fronteiras</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce z-20">
        <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center cursor-pointer" onClick={() => scrollToSection('about')}>
          <div className="w-1 h-3 bg-white rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
}
